










import Vue from 'vue'
import { mdiEmail } from '@mdi/js'
import { ruleIsEmail, validateEmail } from '@/utils'

export default Vue.extend({
    name: 'BaseFieldEmail',
    inheritAttrs: false,

    props: {
        isValid: Boolean,
    },

    data: () => ({ mdiEmail }),

    computed: {
        attrs(): object {
            return {
                label: 'E-mail',
                rules: [this.ruleIsEmail],
                type: 'email',
                ...this.$attrs,
            }
        },

        isEmailValid(): boolean {
            return this.validateEmail(this.$attrs.value)
        },
    },

    watch: {
        isEmailValid: {
            immediate: true,
            handler(isValid: boolean) {
                this.$emit('update:is-valid', isValid)
            },
        },
    },

    methods: {
        ruleIsEmail,
        validateEmail,
    },
})
